// SocialShare.js
import React from 'react';
import {
    FacebookShareButton,
    TwitterShareButton,
    PinterestShareButton,
    LinkedinShareButton, 
} from 'react-share';

// SocialShare component
const SocialShare = ({ url, title }) => {
    return (
        <>
        <div className="social-share-container mb-3 mb-lg-4 d-none">
        <p className='text-center mb-3 mb-lg-4'>SHARE THE SITE WITH YOUR COMMUNITY</p>
            {/* Instagram Share */} 
            <a href={`https://www.instagram.com/?url=${url}`} target="_blank" rel="noopener noreferrer">
                <img src="../social/insta.png"  className="img-fluid mx-auto icon-box text-center" alt="Instagram" />
            </a>
            {/* Facebook Share */}
            <FacebookShareButton url={url} quote={title}>
                <img
                    src="../social/fb.png"
                    className="img-fluid mx-auto icon-box text-center"
                    alt="facebook"
                />
            </FacebookShareButton>

            {/* Twitter Share */}
            <TwitterShareButton url={url} title={title}>
                <img
                    src="../social/x.png"
                    className="img-fluid mx-auto icon-box text-center"
                    alt="twitter"
                />
            </TwitterShareButton>

            {/* Pinterest Share */}
            <PinterestShareButton url={url} media={url}>
                <img
                    src="../social/print.png"
                    className="img-fluid mx-auto icon-box text-center"
                    alt="Pinterest"
                />
            </PinterestShareButton>

            {/* LinkedIn Share */}
            <LinkedinShareButton url={url}>
                <img
                    src="../social/linkedin.png"
                    className="img-fluid mx-auto icon-box text-center"
                    alt="LinkedIn"
                />
            </LinkedinShareButton>


        </div>
        </>

    );
};

export default SocialShare;
